// theme.js
export const lightTheme = {
  colors: {
    primary: "#0066FF",
    shades: {
      100: "#FFFFFF",
      99: "#FDFAFF",
      98: "#F9F7FF",
      95: "#ECEEFF",
      90: "#D7DDFF",
      80: "#AFBEFD",
      70: "#889FFC",
      60: "#6182FC",
      50: "#3865FB",
      40: "#264DCD",
      35: "#2143B2",
      30: "#1C3998",
      25: "#18307F",
      20: "#132768",
      10: "#0C183F",
    },
    newColors: {
      primaryText: "#fafbfc",
      shades: {
        100: "#FEFEFE",
        bg1: "#FCFCFC",
        bgOn: "#FCFCFC",
        bg2: "#F6F6F6",
        bg3: "#F6F6F6",
        bg02: "#dcdcdc 25%",
        bg002: "#e9e9e9 37%",
        bg0002: "#dcdcdc 63%",
        90: "#DEDEE9",
        80: "#BEBFC9",
        70: "#A0A0AB",
        matn2: "#84858F",
        60: "#6A6B74",
        50: "#52545C",
        40: "#3E3E46",
        title: "#333538",
        30: "#2A2B32",
        20: "#191B21",
      },
      otherColors: {
        green: "#18C08F",
        red: "#F03A47",
        yellow: "#FFC107",
        orange: "#FFC700",
        menuBg: "#FFFFFF",
        themeBtn: "#cbced0",
        headerMenu: "#000000",
        iconBg: "#E9E9E9",
        iconText: "#353535",
        bgContainer: "#FCFCFC",
        inputBg: "#FCFCFC",
        inputBorder: "#BABABA",
        inputPlaceholder: "#BEBFC9",
        buttonPrimaryText: "#D7DDFE",
        secondaryBtn: "#0066FF",
        secondaryBtnBorder: "none",
        secondaryBtnText: "#fafbfc",
        garyBtn: "#E9E9E9",
        grayBtnText: "#353535",
        toggleBg: "white",
        btnIconBg: "#E9E9E9",
        btnIconText: "#353535",
        gray: "#898989",
        confirmed: "#D4E9FA",
        containerPrimary: "#F5F9FF",
        offerbg: "#D7FBF0",
        offerbg2: "#FF00001F",
      },
    },
  },
  spacing: {
    8: "8px",
    16: "16px",
    24: "24px",
    32: "32px",
    40: "40px",
    56: "56px",
    72: "72px",
    80: "80px",
    96: "96px",
    120: "120px",
  },
};

export const darkTheme = {
  colors: {
    primary: "#FFC700",
    shades: {
      100: "#FFFFFF",
      99: "#FEBFFF",
      98: "#FDF7EF",
      95: "#FAECCB",
      90: "#F6DA8D",
      80: "#E5B623",
      70: "#C29B1E",
      60: "#A08019",
      50: "#816614",
      40: "#655010",
      35: "#57460E",
      30: "#4A3C0C",
      25: "#3F3A0A",
      20: "#342A09",
      10: "#201A06",
    },
    newColors: {
      primaryText: "#000000",
      shades: {
        100: "#DEDEE9",
        bg1: "#000000",
        bgOn: "#A0A0AB",
        bg2: "#000000",
        bg3: "#1A1A18",
        bg02: "#2a2a2a 25%",
        bg002: "#3a3a3a 37%",
        bg0002: "#2a2a2a 63%",
        90: "#6A6B74",
        80: "#52545C",
        70: "#3E3E46",
        matn2: "#333538",
        60: "#2A2B32",
        50: "#191B21",
        40: "#989a9c",
        title: "#DEDEE9",
        30: "#DEDEE9",
        20: "#08090A",
      },
      otherColors: {
        green: "#18C08F",
        red: "#F03A47",
        yellow: "#FFC107",
        orange: "#FFC700",
        menuBg: "#1A1A18",
        themeBtn: "#000000",
        headerMenu: "#FFFFFF",
        iconBg: "#3B3B3B",
        iconText: "#949494",
        bgContainer: "#1A1A18",
        inputBg: "#2C2C2C",
        inputBorder: "#454545",
        inputPlaceholder: "#84858F",
        buttonPrimaryText: "#191B21",
        secondaryBtn: " #004531",
        secondaryBtnBorder: "#18c08f",
        secondaryBtnText: "#18c08f",
        garyBtn: "#3B3B3B",
        grayBtnText: "#FFFFFF",
        toggleBg: "black",
        btnIconBg: "#3B3B3B",
        btnIconText: "#949494",
        gray: "#969696",
        confirmed: "#ffc70021",
        containerPrimary: "#2C2C2C",
        offerbg: "#1A352B",
        offerbg2: "#3F1614",
      },
    },
  },
  spacing: {
    8: "8px",
    16: "16px",
    24: "24px",
    32: "32px",
    40: "40px",
    56: "56px",
    72: "72px",
    80: "80px",
    96: "96px",
    120: "120px",
  },
};
